import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import {
  Layout,
  HoInvitedHero,
  HoInvitedReadyToStart,
  NewsLetterBar,
} from '../../../v2/components/common';
import {
  InvitedByContractorBetterSection,
  InvitedByContractorBetterWayToBuild,
} from '../../../v2/components/invited-by-contractor';

const InvitedByContractor: React.FC = () => (
  <Layout showDivider={false}>
    <HoInvitedHero
      header="Why did my contractor invite me to use HOVER?"
      body="HOVER quickly transforms photos of your home into a 3D model so
      you can easily visualize your project and know exactly what it will cost
       before the work begins—good contractor, huh?"
      backgroundColor="brandNavy.500"
    >
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="invited by contractor hero"
        src="../../../v2/assets/images/invited_by_contractor_hero.png"
      />
    </HoInvitedHero>
    <InvitedByContractorBetterSection />
    <InvitedByContractorBetterWayToBuild />
    <HoInvitedReadyToStart backgroundColor="brandNavy.500" />
    <NewsLetterBar iconColor="brandYellow.500" bg="brandGreen.500" />
  </Layout>
);

export default InvitedByContractor;
